@if (prescriptions.length > 0) {
  <table class="table table-sm border mb-0">
    <thead>
      <tr>
        <th class="text-dark drug-col">DRUG (AKA)</th>
        <th class="text-dark text-end text-nowrap">WRITTEN DATE &#x25BC;</th>
        <th class="text-dark text-center">VALID REFERRAL?</th>
        <th class="text-dark text-center">SUBMITTED TO R1</th>
      </tr>
    </thead>
    <tbody>
      @for (prescriptionOption of prescriptionOptions; track prescriptionOption) {
        <tr>
          <td>
            @if (prescriptionOption.drugs && prescriptionOption.drugs.length > 0) {
              @for (drug of prescriptionOption.drugs; track drug) {
                <div class="mb-2">
                  <div>{{ drug.name }}</div>
                  <div class="small"><strong>NDC:</strong> {{ drug.ndc }} @if (drug.flaggedForEsp) {
                  <span class="flagged-for-esp p-1">ESP</span>
                }</div>
                <div class="small">{{ drug.manufacturer }}</div>
              </div>
            }
          }
          <div class="small">
            {{ prescriptionOption.prescriptionFamily.akas && prescriptionOption.prescriptionFamily.akas | slice:0:4 | joinList }}
          </div>
        </td>
        <td class="text-end">{{ prescriptionOption.writtenDate | date: 'MM/dd/yyyy' }}</td>
        <td class="text-center">
          @for (verification of prescriptionOption.verifications; track verification) {
            @if (verification.valid) {
              <div>
                <fa-icon [icon]="['fas', 'check']" class="check" />
                {{ verification.referralDate | date: 'MM/dd/yyyy' }}
              </div>
            }
          }
          @if (prescriptionOption.showWarning) {
            <div class="referral-date-warning d-flex justify-content-around">
              <div><fa-icon [icon]="['fas', 'exclamation-triangle']" class="warning" /></div>
              <div class="warning-message">
                <p>A documentation dated before the prescription written date is needed.</p>
                @if (canAddVerifications && !formDisabled) {
                  <a href="#addReferral" (click)="onAddReferralClick($event)">
                    Add Referral
                  </a>
                }
              </div>
            </div>
          }
        </td>
        <td class="text-center">
          @if (prescriptionOption.submitted) {
            <app-client-task-submitted-prescription
              [verified]="prescriptionOption.verified"
              [rejected]="prescriptionOption.rejected"
              [submission]="prescriptionOption.submission"
              />
          }
        </td>
      </tr>
    }
  </tbody>
</table>
} @else {
  <section><p>There are no prescriptions.</p></section>
}
